import Swal from "sweetalert2";

async function Health(laboratorio) {
  const requestOptions = {
    method: "GET",
    headers: {
      laboratorio: laboratorio,
    },
  };

  try {
    const response = await fetch(process.env.REACT_APP_ESSILOR_API + "gestao-pedidos-laboratorio/v1/health", requestOptions);

    if (response.ok) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Erro na verificação de health:", error);
    return false;
  }
}

export { Health };
